import { render, staticRenderFns } from "./widget_opiniones_curso_avanzado.vue?vue&type=template&id=1d1758f1&scoped=true&"
import script from "./widget_opiniones_curso_avanzado.vue?vue&type=script&lang=js&"
export * from "./widget_opiniones_curso_avanzado.vue?vue&type=script&lang=js&"
import style0 from "./widget_opiniones_curso_avanzado.vue?vue&type=style&index=0&id=1d1758f1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1758f1",
  null
  
)

export default component.exports